<template>
  <div class="award-page">
    <header-pane
      class="award-page__header"
      colorType="light"
      :pageTitle="$tc('LinkPage.pageTitle')"
      navigationCurrent="link"
    />
    <sub-header-section
      :pageTitle="$tc('LinkPage.AwardPage.pageTitle')"
      :execTransitionEventParent="true"
      @onClick="backToPreviousPage"
    />

    <award-pane class="award-page__content" />

    <global-navigation-pane current="link" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import HeaderPane from '@/components/common/Header/HeaderPane.vue'
import GlobalNavigationPane from '@/components/common/GlobalNavigation/GlobalNavigationPane.vue'
import AwardPane from '@/components/LinkPage/AwardPane.vue'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'

/**
 * SFgo Award ページ
 */
export default defineComponent({
  name: 'AwardPage',
  components: {
    SubHeaderSection,
    HeaderPane,
    GlobalNavigationPane,
    AwardPane,
  },
  methods: {
    /**
     * 前のページに遷移する
     */
    backToPreviousPage() {
      return this.$router.back()
    },
  },
})
</script>

<style lang="scss" scoped>
.award-page {
  background: $gray1;
  min-height: var(--screen-height);
  padding-bottom: var(--safe-area-inset-bottom);
}
</style>
